<template>
    <div>
        <div v-if="chatting_available && channel.use_chatting_service">
            <div v-if="chatting_type ==='chatroll' && 'embed_code' in chatting_info">
                <iframe id="kollus_chat" width="100%" height="440px" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" allowtransparency="true" v-if="chatting_info && 'admin_embed_src' in chatting_info" :src="chatting_info.admin_embed_src"></iframe>
                <div class="form-guide-box is-center">
                    <p class="form-guide"><i class="icon icon-info-circle-line"></i>{{ $t('paragraphs.chatting_concurrent_user_tip1')}} {{ $t('paragraphs.chatting_concurrent_user_tip2')}}</p>
                </div>
            </div>
            <div v-else-if="chatting_type==='kollus'" style="width:100%;height:440px;">
                <div id="kollus_chatting"></div>
            </div>
        </div>
        <div v-else class="form-guide-box is-center">
            <svg width="62px" height="59px" viewBox="0 0 62 59" class="form-guide-icon">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                    <g id="icon-chat" transform="translate(1.000000, 1.000000)" stroke="#228be6" stroke-width="2">
                        <path d="M25.001,47.911 C28.711,50.453 33.615,52 39,52 C41.403,52 43.702,51.677 45.852,51.111 L54,56 L54,47.187 C57.708,44.302 60,40.356 60,36 C60,33.876 59.455,31.851 58.468,29.999" id="Path"></path>
                        <path d="M27,0 C12.088,0 0,9.402 0,21 C0,25.997 2.253,30.58 6,34.186 L6,48 L19.626,41.187 C21.973,41.705 24.44,42 27,42 C41.912,42 54,32.598 54,21 C54,9.402 41.912,0 27,0 Z" id="Path"></path>
                        <path d="M13,16 L41,16" id="Path"></path>
                        <path d="M13,27 L29,27" id="Path"></path>
                    </g>
                </g>
            </svg>
            <p class="form-guide mb-1"><i class="icon icon-info-circle-line"></i>{{ $t('paragraphs.chatting_not_available_desc1')}}</p>
            <p>{{ $t('paragraphs.chatting_not_available_desc2')}} {{ $t('paragraphs.chatting_not_available_desc3')}}</p>
        </div>
    </div>
<!--        <div v-if="chattingAvailable && chatting_info && 'embed_code' in chatting_info">-->
<!--            <div v-if="chattingType === 'chatroll'">-->

<!--            </div>-->
<!--            <div v-if="chattingType === 'kollus'">-->
<!--                <kollus-chatting v-if="chattingIframe" :chatroll-info="chattingMediaInfo"></kollus-chatting>-->
<!--            </div>-->
<!--        </div>-->
</template>
<script>
import loadJsCss from 'load-js-css';
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    name: 'kollus-chatting',
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        chatting_available: {
            type: Boolean,
            required: true,
        },
        chatting_type: {
            type: String,
            required: true,
        },
        chatting_started: {
            type: String,
            required: true,
        },
        channel: {
            type: Object,
            required: true,
        },
        creator_code: {
            type: String,
            required: false,
        },
        caller: {
            type: String,
            required: true,
        },
        chatting_status: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            chatting_info: {},
            chattingSocket: {},
        };
    },
    beforeMount() {
        this.loadChattingResource();
    },
    mounted() {
    },
    methods: {
        loadChattingResource() {
            const apiUrl = '/chatting-resources';
            axios.get(apiUrl).then((response) => {
                loadJsCss.list(response.data);
            });
        },
        initChat() {
            this.getChattingInfo();
        },
        getChattingInfo() {
            let apiUrl = '';
            if (this.caller === 'creator') {
                apiUrl = `/console/creators/${this.creator_code}/channel/chatting-info`;
            } else {
                apiUrl = `/console/service-accounts/${this.selectedServiceAccount.key}/channels/${this.channel.key}/chatting-info`;
            }
            const self = this;
            axios.get(apiUrl).then((response) => {
                self.chatting_info = response.data.data;
                if (this.kollusChatting) {
                    self.kollusChattingInit(self.chatting_info, 'pc', (e)=> {});
                }
            });
        },
        // kollus chatting begin
        kollusChattingInit(options, device, callback) {
            const chattingData = options.info;
            if (chattingData.room_id === '' || chattingData.chatting_server === '') {
                return;
            }
            KOLLUS_CHATTING._KollusChatting.init({
                mode: device,
                chattingArea: '#kollus_chatting',
                chatting: {
                    admin: true,
                    userId: chattingData.user_id,
                    roomId: chattingData.room_id,
                    rooms: chattingData.rooms || [],
                    nickName: 'Admin',
                    photoUrl: '',
                    chattingUrl: chattingData.chatting_server,
                    locale: this.$cookie.get('locale'),
                },
            });
        },
        // kollus chatting end
        kollusChattingRelease() {
            console.log('chatting.released');
            KOLLUS_CHATTING._KollusChatting.release();
        },
    },
    computed: {
        kollusChatting() {
            return (this.chatting_available && this.channel.use_chatting_service && this.chatting_type === 'kollus');
        },
        chatRollChatting() {
            return (this.chatting_available && this.channel.use_chatting_service && this.chatting_type === 'chatroll');
        },
        doLoadedPage() {
            if (this.caller === 'channel') {
                return this.chatting_started !== '' && this.loadedServiceAccount &&
                    this.channel.key !== '';
            } else if (this.caller === 'creator') {
                return this.chatting_started !== '' && this.creator_code !== '';
            }
            return false;
        },
    },
    watch: {
        doLoadedPage(newValue) {
            if (newValue) {
                this.initChat();
            }
        },
        chatRollChatting(newValue, oldValue) {
            if (newValue) {
                this.initChat();
            }
        },
        chatting_status(newValue, oldValue) {
            if (newValue !== oldValue && newValue === 'deleted') {
                this.kollusChattingRelease();
            }
        },
        // onKollusChatting(newValue) {
        //     if (newValue) {
        //         this.initKollusChat();
        //     }
        // },
    },
};
</script>

<style scoped>
#kollusChattroll {
    height: 100%;
    width: 100%;
}
</style>
